import { useContext } from 'react'

import { HouseContext, HValidation } from './HouseContext'

export function useHouse(): HValidation {
  const context = useContext(HouseContext)
  return context
}
